import axios from "axios";
import { errorToaster } from "../helper/toasterConfiguration";
const token = () => {
  if (localStorage.getItem("token")) {
    return `Bearer ${localStorage.getItem("token")}`;
  }
  return "";
};
const handleUnauthorizedError = () => {
  localStorage.clear();
  window.location.href = "/";
  return { message: "Please login to continue." };
};

function extractErrorMessages(message) {
  if (typeof message === "string") {
    return message; // Directly return if it's a string
  } else if (typeof message === "object") {
    return Object.values(message).flat().join(", "); // Flatten any array of messages
  } else if (Array.isArray(message)) {
    return message.join(", ");
  }
  return "An unknown error occurred."; // Fallback message
}
export const Helper = {
  Get: async ({ url, hasToken = true, data = null }) => {
    try {
      const response = await axios.get(
        url,
        hasToken
          ? {
              headers: {
                Authorization: token(),
              },
              params: data ? data : {},
            }
          : {
              headers: {},
              params: data ? data : {},
            }
      );
      if (response.success && response.status === 200) {
        return {
          message: response.data.message,
          response: response.data,
        };
      } else {
        return {
          message: response.data.message,
          response: response.data,
        };
      }
    } catch (err) {
      if (err.response) {
        const err_response = err.response.data;
        if (err.response.status === 403) {
          return handleUnauthorizedError();
        } else if (err.response.status === 401) {
          return handleUnauthorizedError();
        } else if (err.response.status === 422) {
          // err_response?.errors?.map((error) => errorToaster(error));
          return { message: err_response.data };
          return;
        } else if (
          err_response.success !== undefined &&
          err_response.data !== undefined
        ) {
          if (err_response.data.length > 0) {
            return { message: err_response.data };
          } else {
            return { message: err_response.message };
          }
        }
      }

      // Default error message
      return { message: err.message };
    }
  },
  Get_Abort: async ({ url, hasToken = true, data = null, signal }) => {
    try {
      const response = await axios.get(
        url,
        hasToken
          ? {
              headers: {
                Authorization: token(),
              },
              params: data ? data : {},
              signal: signal,
            }
          : {
              params: data ? data : {},
              signal: signal,
              headers: {},
            }
      );
      if (response.success && response.status === 200) {
        return {
          message: response.data.message,
          response: response.data,
        };
      } else {
        return {
          message: response.data.message,
          response: response.data,
        };
      }
    } catch (err) {
      console.log(err);

      if (err.response) {
        const err_response = err.response.data;

        if (err.response.status === 403) {
          return handleUnauthorizedError();
        } else if (err.response.status === 401) {
          return handleUnauthorizedError();
        } else if (err.response.status === 422) {
          err_response?.errors?.map((error) => errorToaster(error));
          return;
        } else if (
          err_response.success !== undefined &&
          err_response.data !== undefined
        ) {
          if (err_response.data.length > 0) {
            return { message: err_response.data };
          } else {
            return { message: err_response.message };
          }
        }
      }

      // Default error message
      return { message: err.message };
    }
  },
  Post: async ({ url, hasToken = true, data = null, showErrors }) => {
    try {
      const response = await axios.post(
        url,
        data,
        hasToken
          ? {
              headers: {
                Authorization: token(),
                // ApiKey: "your_api_key_here"
              },
            }
          : {
              headers: {
                // ApiKey: "your_api_key_here"
              },
            }
      );

      if (response.data.success && response.status === 200) {
        return {
          message: response.data.message,
          response: response.data,
        };
      } else {
        return {
          message: response.data.message,
          response: response.data,
        };
      }
    } catch (err) {
      if (err.response.data.message){
        errorToaster(err.response.data.message);
      }

      console.log(err);

      if (err.response) {
        const err_response = err.response.data;

        // Handle specific status codes
        if (err.response.status === 403) {
          return handleUnauthorizedError();
        } else if (err.response.status === 401) {
          return handleUnauthorizedError();
        } else if (err.response.status === 400) {
          // Handle validation errors
          return {
            message: extractErrorMessages(err_response.errors),
          };
        } else if (err.response.status === 422) {
          showErrors?.map((item) =>
            err_response?.errors[item]?.map((err) => {
              errorToaster(err);
            })
          );
          return;
        } else if (
          err_response.success !== undefined &&
          err_response.data !== undefined
        ) {
          if (err_response.data.length > 0) {
            return { message: err_response.data.join(", ") }; // Join multiple messages if needed
          } else {
            return { message: err_response.message };
          }
        }
      }

      // Default error message
      return { message: err.message };
    }
  },
  Put: async ({ url, hasToken = true, data = null }) => {
    try {
      // Construct headers dynamically
      const headers = hasToken
        ? {
            Authorization: token(),
            "Content-Type": "application/json",
          }
        : {
            "Content-Type": "application/json",
          };

      // Make the PUT request
      const response = await axios.put(url, data, { headers });

      // Check response status
      if (response.status === 200) {
        return {
          message: response.data.message || "Request successful",
          response: response.data,
        };
      } else {
        return {
          message: response.data.message || "Unexpected response",
          response: response.data,
        };
      }
    } catch (err) {
      console.error("Error during PUT request:", err);

      // Handle errors with a response
      if (err.response) {
        const { data: errResponse, status } = err.response;

        if (status === 403) {
          return handleUnauthorizedError();
        } else if (status === 401) {
          return handleUnauthorizedError();
        } else if (err.response.status === 422) {
          err?.response?.data?.errors?.map((error) => errorToaster(error));
          return;
        }

        return {
          message: errResponse.message || "An error occurred.",
        };
      }

      // Handle network or unknown errors
      return { message: err.message || "An unexpected error occurred." };
    }
  },
  Delete: async ({ url, hasToken = true, data = null }) => {
    try {
      const response = await axios.delete(
        url,
        hasToken
          ? {
              headers: {
                Authorization: token(),
                //    ApiKey: "acO+4JTx8lmZmOo4qZemnKS7JufhcyviuvUaz5VL7faQo60isZFx/sf7FbtNs1FlkLG03/HsIs+6odEwY/30HrST7JZaDsAmTMrvB0qm25LqxoZquKThjgW9S6NCX8lWWLhp6mUOCBfe86B0dcgEhe9SXgmFVqA8UvzZ+G+YC8Y="
              },
              // params : data ? data : {}
            }
          : {
              headers: {
                //  ApiKey: "acO+4JTx8lmZmOo4qZemnKS7JufhcyviuvUaz5VL7faQo60isZFx/sf7FbtNs1FlkLG03/HsIs+6odEwY/30HrST7JZaDsAmTMrvB0qm25LqxoZquKThjgW9S6NCX8lWWLhp6mUOCBfe86B0dcgEhe9SXgmFVqA8UvzZ+G+YC8Y="
              },
            },
        data
      );

      if (response.success && response.status === 200) {
        return {
          message: response.data.message,
          response: response.data,
        };
      } else {
        return {
          message: response.data.message,
          response: response.data,
        };
      }
    } catch (err) {
      console.log(err);

      if (err.response) {
        const err_response = err.response.data;

        if (err.response.status === 403) {
          return handleUnauthorizedError();
        } else if (err.response.status === 401) {
          return handleUnauthorizedError();
        } else if (err.response.status === 422) {
          err_response?.errors?.map((error) => errorToaster(error));
          return;
        } else if (
          err_response.success !== undefined &&
          err_response.data !== undefined
        ) {
          if (err_response.data.length > 0) {
            return { message: err_response.data };
          } else {
            return { message: err_response.message };
          }
        }
      }

      // Default error message
      return { message: err.message };
    }
  },
};
